import React from "react";
import "./Section2.css";
import Section2Image from "../../../../../assets/images/itinsrsec2-img1.png";
import ProfDots from "../../../../../assets/images/aboutus-dots.png";
const Section2 = () => {
  return (
    <div className="fatcasrsec2_section">
      <img src={ProfDots} alt="" className="fatcasrsec2__section_dots" />
      <div className="fatcasrsec2__section_left">
        <div className="fatcasrsec2__secleft_heading">
          What is a Foreign Financial Account?
        </div>
        <div className="fatcasrsec2__secleft_description">
          <p>
            Financial accounts include the following types of accounts: Bank
            accounts such as savings accounts, checking accounts, and time
            deposits. Securities accounts such as brokerage accounts and
            securities derivatives or other financial instruments accounts.
            Insurance policies with a cash value (such as a whole life insurance
            policy) Mutual funds or similar pooled funds (i.e., a fund that is
            available to the general public with a regular net asset value
            determination and regular redemptions) Typically, a financial
            account that is maintained with a bank or financial institution
            located outside of the United States is a foreign financial account.
          </p>
          <p>
            If two persons jointly maintain a foreign financial account, or if
            several persons each own a partial interest in an account, then each
            U.S. person has a financial interest in that account and each person
            must report the entire value of the account on an FBAR (exceptions
            may apply in the case of a married couple).
          </p>
        </div>
      </div>
      <div className="fatcasrsec2__section_right">
        <img src={Section2Image} alt="" className="fatcasrsec2__section_img" />
      </div>
    </div>
  );
};

export default Section2;
